/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { CheckCircle } from "@mui/icons-material"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useHistory } from "react-router-dom"
import { paths, VerticaisManager } from "src/components/vendas/VerticaisManager"
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api"
import { useObservable } from "src/framework/store/storeUtil"
import { setDimensionadoDrawerStatus, setVendedorInternoModalStatus } from "src/store/vendas/projetos/actions"
import { dimensionadoStore$, formState$, modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store"
import { DimensionadoStoreType } from "src/store/vendas/projetos/types"
import theme from "src/theme/light"
import { DEFAULT_PROJETO, NOVO_PROJETO_ENGENHARIA, POTENCIA_MINIMA_ENGENHARIA, POTENCIA_MINIMA_VERTICAL } from "../constants"
import { Projeto } from "../types"
import { Configuracoes } from "./containers/Configuracoes"
import { InformationDrawer } from "./containers/InformationDrawer"
import { Inversores } from "./containers/Inversores"
import { Modulos } from "./containers/Modulos"
import { IComponenteQuantidade, Solucao } from "./containers/Solucao"
import { ValorTotal } from "./containers/ValorTotal"
import { salvarProjeto } from "../utils/salvarProjeto"
import { projetoSalvoComSucessoDialog } from "../utils/projetoSalvoComSucessoDialog"
import { BehaviorSubject } from "rxjs"
import { resetarProjeto } from "src/components/projetos/utils/resetarProjeto"
import { redirecionarParaProjetosEspeciais } from "../utils/redirecionarParaProjetosEspeciais"
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types"
import { authUser$ } from "src/framework/components/navigations/MenuUser"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { verificaPendenciaTrocaComponente } from "../utils/verificaPendenciaTrocaComponente"
import { showPendenciaTrocaComponenteAlert } from "../utils/showPendenciaTrocaComponenteAlert"
import adminStore from "src/store/AdminStore"
import { ModalDetalhes as ModalDetalhesComponente } from "src/components/componentes/ModalDetalhes"
import { LoginStore } from "src/framework/store/LoginStore";
import { isLoading$ } from "src/framework/store/ApiEvents";
import { notifierStore } from "src/framework/store/NotifierStore";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";

export type TabName = 'configuracoes' | 'modulos' | 'inversores' | 'solucao' | 'valor_total'

interface TabProps {
  name: TabName;
  label: string;
  done: boolean;
  disabled: boolean;
}

const useStyles = makeStyles({
  tabIcon: {
    marginRight: 8,
    fontSize: 22
  }
})

export const quantidadesMinimas$ = new BehaviorSubject<IComponenteQuantidade[]>([]);

const manager = new VerticaisManager(paths, api, apiNoLoading);

const ProjetoDimensionado = () => {
  const classes = useStyles()
  const history = useHistory();
  
  const modalComponentesDetalhesData = useObservable(modalComponentesDetalhesData$)
  const globalFormState = useObservable(formState$)
  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const dimensionadoStore = useObservable<DimensionadoStoreType>(dimensionadoStore$)
  const permissoes = useObservable(LoginStore.permissoes) || [];
  
  const [projeto, setProjeto] = useState<Projeto>(DEFAULT_PROJETO)
  const [formState, setFormState] = useState<Projeto>(DEFAULT_PROJETO)
  const [tab, setTab] = useState<TabName>('configuracoes')

 const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  useEffect(()=>{
    if (globalFormState) {
      setFormState(globalFormState)
      setProjeto(globalFormState)
    }
  },[globalFormState])

  const afterSave = useCallback((response: IDataResponse) => {
    isLoading$.next(false);
    projetoSalvoComSucessoDialog(response?.data?.[0]?.codigo_venda, history, {
      tipoProjeto: formState?.tipo,
    })
  }, [history, formState?.tipo])

  const save = useCallback((updatedFormState: Partial<Projeto> = {})=>{
    const payload = {
      ...formState,
      ...updatedFormState,
    }

    salvarProjeto(manager, formState?.id, payload, authUser, formState.clonar_projeto).then((response: IDataResponse) => {
      const allowedStatusCode = [STATUS_CODE.OK, STATUS_CODE.CREATED]
      if(allowedStatusCode.includes(response.statusCode)) {
        afterSave(response)
      }
    })
  },[afterSave, formState])

  const beforeSave = useCallback(() => {
    formState.lista_termo_simulacao_financiamento = formState$.value.lista_termo_simulacao_financiamento;
    const withPermission = PermissionUtil.can(PermissionUtil.PERMISSION_VENDEDORES_LISTAGEM, permissoes);
    if (withPermission && (!formState.isEdit || formState?.alterou_segmento || formState.clonar_projeto)) {
      setVendedorInternoModalStatus(true, (vendedor) => {
        save({ vendedor_interno: vendedor })
      })
    } else {
      save()
    }
  },[formState, save, permissoes])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = formState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[formState?.modulosList]);

  const potenciaInvalida = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_ENGENHARIA;
  },[potenciaTotal]);

  const alertaProjetoPotencia = useCallback(async() => {
    if (potenciaInvalida) {
      redirecionarParaProjetosEspeciais({
        onNegation: () => {
          formState$.next({...resetarProjeto(formState), ...NOVO_PROJETO_ENGENHARIA })
          history.push('/projetos/verticais/novo',{ allowAccess: true })
        },
      });
    }
  },[potenciaInvalida])

  const alertaValorMargemInvalido = useCallback(async() => {
    notifierStore.setNotifier({
      title: 'Atenção',
      content: [
        '<strong>Retorno financeiro</strong>',
        '</br>',
        'O valor da margem não pode ser maior do que o valor da instalação.'
      ],
      onClose: () => {
        notifierStore.setOpen(false)
      },
      timeOut: 6000,
    })
    notifierStore.setOpen(true)
  },[])

  const valorMargemMaiorQueValorServico = useMemo(()=>{
    if (formState.tipo_proposta?.value !== 'gerador-com-instalacao') return false
    return  Number(formState.valor_servico || 0) < Number(formState.valor_margem_produtos || 0)
  },[formState.tipo_proposta, formState.valor_margem_produtos, formState.valor_servico])

  const handleSave = useCallback(async() => {
    if (potenciaInvalida) {
      alertaProjetoPotencia();
      return;
    }

    if (valorMargemMaiorQueValorServico) {
      alertaValorMargemInvalido()
      return
    }

    if (formState?.isEdit) {
      const dataProjeto: Projeto | any = {...formState};
      if (formState?.id) {
        await adminStore.getProjetoTrocasPendentes(formState?.id).then((resp) => {
          if (resp && resp?.componentes) dataProjeto.componentes = resp?.componentes;
          if (resp && resp?.componentes_modificados) dataProjeto.componentes_modificados = resp?.componentes_modificados;
        });
      }
      if (verificaPendenciaTrocaComponente(dataProjeto)) {
        showPendenciaTrocaComponenteAlert();
        return;
      }
    }

    beforeSave()
  },[beforeSave, formState.isEdit, formState.simulacao_financiamento?.simulacoes, potenciaInvalida, valorMargemMaiorQueValorServico])

  const alterarCodigoVenda = useCallback((codigoVenda, segmento) => {
    const vertical = segmento?.includes('vertical');
    if (vertical && !codigoVenda?.includes('PROV')) {
      return codigoVenda?.replace('PROJ', 'PROV');
    } else if (!vertical && !codigoVenda?.includes('PROJ')) {
      return codigoVenda?.replace('PROV', 'PROJ');
    }
    return codigoVenda;
  }, []);

  useEffect(() => {
    const recalcular = async () => {
      let segmentoProjeto = projeto.segmento;
      if (potenciaTotal > POTENCIA_MINIMA_VERTICAL) {
        if (projeto.segmento?.includes('offgrid')) segmentoProjeto = 'vertical_offgrid';
        else segmentoProjeto = 'vertical_ongrid';
      } else {
        if (projeto.segmento?.includes('offgrid')) segmentoProjeto = 'distribuicao_offgrid';
        else segmentoProjeto = 'distribuicao_ongrid';
      }

      const alterouSegmento = formState.segmento !== segmentoProjeto;
      if (alterouSegmento) {
        const state = {...formState};
        const codigoVenda = alterarCodigoVenda(formState.codigo_venda, segmentoProjeto);

        state.segmento = segmentoProjeto;
        state.codigo_venda = codigoVenda;
        state.alterou_segmento = alterouSegmento;
        state.auto_comissao = true;
        state["@proposta_atualizada"] = true
        setFormState(state);
      }
    }

    const alterouCodigoVenda = formState.codigo_venda && formState.codigo_venda !== projeto.codigo_venda;
    if ((potenciaTotal && Number(potenciaTotal) !== Number(projeto?.potencia)) || alterouCodigoVenda) {
      recalcular();
    }
  }, [potenciaTotal, projeto, formState.codigo_venda])

  const tabs = useMemo<TabProps[]>(() => {
    const modulosDisabled = dimensionadoStore?.tabs.modulos.disabled || false
    const inversoresDisabled = modulosDisabled || dimensionadoStore?.tabs.inversores.disabled || false
    const solucaoDisabled = inversoresDisabled || dimensionadoStore?.tabs.solucao.disabled || false
    const valorTotalDisabled = solucaoDisabled || dimensionadoStore?.tabs.valor_total.disabled || false

    return [
      {
        name: 'configuracoes',
        label: 'Configurações',
        done: !modulosDisabled,
        disabled: false
      },
      { 
        name: 'modulos',
        label: 'Módulos',
        done: !inversoresDisabled,
        disabled: modulosDisabled
      },
      {
        name: 'inversores',
        label: 'Inversores',
        done: !solucaoDisabled,
        disabled: inversoresDisabled
      },
      {
        name: 'solucao',
        label: 'Solução',
        done: !solucaoDisabled,
        disabled: solucaoDisabled
      },
      {
        name: 'valor_total',
        label: 'Valor Total',
        done: dimensionadoStore?.tabs.valor_total.done || false,
        disabled: valorTotalDisabled || false
      },
    ]
  },[dimensionadoStore])

  const validate = (): boolean => {
        const messages: string[] = [];
        //verifica se projeto tem inversores
        if(formState?.inversoresList?.every(item => item.quantidade === 0)){
          messages.push("Não é possível finalizar o projeto sem inversor ou microinversor. Adicione o item para prosseguir.");
        }
        if (messages.length > 0) {
          notifierStore.setNotifier({
            title: "Aviso",
            content: messages,
            timeOut: 3500,
            onClose: () => {
              notifierStore.setOpen(false)
            }
          })
          notifierStore.setOpen(true)
          return false;
        }
        return true;
      }

  return (
    <>
      <Paper elevation={0} className="tab-header">
        <TabControl
          indicatorColor="primary"
          onChangeTab={() => {}}
          currentTabName={tab}>
          {tabs.map(item => (
            <TabContent
              disabled
              name={item.name}
              visible={true}
              label={
                <Box display={isMobile ? "none" : "flex"} justifyContent={"center"} alignItems="center">
                  <CheckCircle htmlColor={item.done ? theme.palette.primary.dark : 'unset'} className={classes.tabIcon} />
                  <span style={{ color: theme.palette.text.secondary }}>{item.label}</span>    
                </Box>
              }>
                {item.name === 'configuracoes' && tab === 'configuracoes' && (
                  <Configuracoes
                    formState={formState}
                    onChangeFormState={setFormState}
                    onClickNext={() => setTab('modulos')}
                    onClickBack={() => {
                      formState$.next({ ...formState$.value, ...formState })
                      
                      if (formState.clonar_projeto) {
                        history.replace(`/projetos/${formState.id}/clonar`, { noReset: true })
                        return;
                      }

                      if (formState.isEdit) {
                        history.replace(`/projetos/${formState.id}/edicao`, { noReset: true })
                        return;
                      }
                      
                      history.push('/projetos', { noReset: true })
                    }}
                  />
                )}

                {item.name === 'modulos' && tab === 'modulos' && (
                  <Modulos
                    formState={formState}
                    onChangeFormState={setFormState}
                    onClickNext={() => setTab('inversores')}
                    onClickBack={() => setTab('configuracoes')}
                  />
                )}

                {item.name === 'inversores' && tab === 'inversores' && (
                  <Inversores 
                    formState={formState}
                    projetoOriginal={projeto}
                    onChangeFormState={setFormState}
                    onClickNext={() => setTab('solucao')}
                    onClickBack={() => setTab('modulos')}
                  />
                  )}

                {item.name === 'solucao' && tab === 'solucao' && (
                  <Solucao
                    formState={formState}
                    onChangeFormState={setFormState}
                    onClickNext={() => setTab('valor_total')}
                    onClickBack={(tabBack: TabName = 'inversores') => setTab(tabBack)}
                    onEditarEstruturas={() => {
                      setTab("modulos")
                    }}
                  />
                )}

                {item.name === 'valor_total' && tab === 'valor_total' && (
                  <ValorTotal
                    formState={formState}
                    onChangeFormState={setFormState}
                    onClickNext={()=>{
                      if(!validate()){
                        return;
                      }
                      handleSave()
                    }}
                    onClickBack={() => setTab('solucao')}
                  />
                )}

            </TabContent>
          ))}
        </TabControl>        
      </Paper>

      <InformationDrawer isOpen={dimensionadoStore?.drawerIsOpened || false} close={() => setDimensionadoDrawerStatus(false)} ></InformationDrawer>
    
      {!!modalComponentesDetalhesData && (
        <ModalDetalhesComponente 
          open={!!modalComponentesDetalhesData}
          componentId={modalComponentesDetalhesData}
          setOpenModal={(openStatus: any) => {
            if (!openStatus) modalComponentesDetalhesData$.next(0)
          }}
        />
      )}
    </>
  )
}

export { ProjetoDimensionado }